export var Unit;

(function (Unit) {
  Unit["day"] = "day";
  Unit["month"] = "month";
  Unit["year"] = "year";
})(Unit || (Unit = {}));